import React, { useContext, useState, useEffect } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import { Dialog, Divider, Input, Text, useTheme } from '@rneui/themed';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import ConsumptionContext from '../consumption-context';
import ActivateChatButton from '../components/buttons/ActivateChatButton';
import ShowIntegrityButton from '../components/buttons/ShowIntegrityButton';
import LogoutButton from '../components/buttons/LogoutButton';
import DeleteAccountButton from '../components/buttons/DeleteAccountButton';
import { useAuth } from '../hooks/useAuth';

const PersonalScreen = ({ updateUser, deleteUserAndLogout }) => {
  const { signOut } = useAuth();
  const { t } = useTranslation();
  const { total, userDoc } = useContext(ConsumptionContext);
  const { theme } = useTheme();
  const [length, setLength] = useState('');
  const [weight, setWeight] = useState('');
  const [stdUnitDay, setStdUnitDay] = useState('');
  const [stdUnitWeek, setStdUnitWeek] = useState('');
  const [goalText, setGoalText] = useState('');
  const [showChatEnabled, setShowChatEnabled] = useState(false);

  useEffect(() => {
    if (userDoc) {
      const { length, weight, stdUnitDay, stdUnitWeek, goalText } = userDoc;
      setLength(length || '');
      setWeight(weight || '');
      setStdUnitDay(stdUnitDay || '');
      setStdUnitWeek(stdUnitWeek || '');
      setGoalText(goalText || '');
    }
  }, [userDoc]);

  const enableChat = () => {
    updateUser({ chatEnabled: true });
    setShowChatEnabled(true);
  };

  return (
    <ScrollView contentContainerStyle={styles.contentContainer}>
      <View style={styles.inputView}>
        <Input
          label="Längd i centimeter"
          labelStyle={{ color: theme.colors.primary }}
          placeholder="T ex 170"
          placeholderTextColor="grey"
          keyboardType="numeric"
          value={length}
          onChangeText={setLength}
          onEndEditing={() => updateUser({ length: parseInt(length) })}
          onBlur={() => updateUser({ length: parseInt(length) })}
        />
      </View>
      <View style={styles.inputView}>
        <Input
          label="Vikt i kg"
          labelStyle={{ color: theme.colors.primary }}
          placeholder="T ex 85"
          placeholderTextColor="grey"
          keyboardType="numeric"
          value={weight}
          onChangeText={setWeight}
          onEndEditing={() => updateUser({ weight: parseInt(weight) })}
          onBlur={() => updateUser({ weight: parseInt(weight) })}
        />
      </View>
      <View style={styles.inputView}>
        <Input
          label="Gräns standardglas per dag"
          labelStyle={{ color: theme.colors.primary }}
          keyboardType="numeric"
          value={stdUnitDay}
          onChangeText={setStdUnitDay}
          onEndEditing={() => updateUser({ stdUnitDay: parseInt(stdUnitDay) })}
          onBlur={() => updateUser({ stdUnitDay: parseInt(stdUnitDay) })}
        />
      </View>
      <View style={styles.inputView}>
        <Input
          label="Gräns standardglas per vecka"
          labelStyle={{ color: theme.colors.primary }}
          keyboardType="numeric"
          value={stdUnitWeek}
          onChangeText={setStdUnitWeek}
          onEndEditing={() =>
            updateUser({ stdUnitWeek: parseInt(stdUnitWeek) })
          }
          onBlur={() => updateUser({ stdUnitWeek: parseInt(stdUnitWeek) })}
        />
      </View>
      <View style={styles.inputView}>
        <Input
          label="Beskriv ett mål i text"
          labelStyle={{ color: theme.colors.primary }}
          style={styles.textInputComponent}
          multiline
          numberOfLines={6}
          placeholder=""
          value={goalText}
          onChangeText={setGoalText}
          onEndEditing={() => updateUser({ goalText })}
          onBlur={() => updateUser({ goalText })}
        />
      </View>
      <Divider style={{ marginTop: 30 }} />
      {!userDoc.chatEnabled && (
        <ActivateChatButton total={total} enableChat={enableChat} />
      )}
      <ShowIntegrityButton />
      <LogoutButton logout={signOut} />
      <DeleteAccountButton deleteUserAndLogout={deleteUserAndLogout} />
      <Dialog
        overlayStyle={styles.overlayStyle}
        isVisible={showChatEnabled}
        onBackdropPress={() => setShowChatEnabled(false)}
      >
        <Dialog.Title title="" />
        <Text>{t('chat.newTab')}</Text>
        <Dialog.Actions>
          <Dialog.Button
            title={t('ok')}
            type="solid"
            onPress={() => setShowChatEnabled(false)}
          />
        </Dialog.Actions>
      </Dialog>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  contentContainer: { paddingHorizontal: 20 },
  inputView: { marginTop: 20 },
  buttonView: { marginTop: 40 },
  overlayStyle: {
    backgroundColor: 'white',
  },
  textInputComponent: {
    flex: 1,
    marginTop: 10,
    padding: 10,
    borderRadius: 3,
    borderWidth: 1,
    borderColor: 'lightgrey',
    textAlignVertical: 'top',
    backgroundColor: 'transparent',
    color: 'black',
  },
});

export default PersonalScreen;
